import { GetStaticPaths, GetStaticProps, InferGetStaticPropsType } from "next";
import { Spacing } from "goi_common";

import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import SangjoPageLayout from "@/components/DefaultPageLayout";
import RefundCalculatorDetailContainer from "@/containers/RefundCalculatorContainer/RefundCalculatorDetailContainer";

export const getStaticPaths: GetStaticPaths = async () => {
  const isValidAllSangjos = Object.entries(SANGJO_PRODUCTS).filter(
    ([key, valueList]) => valueList.length > 0,
  );
  const paths = isValidAllSangjos.map(([sangjoProductId, _]) => ({
    params: {
      id: String(sangjoProductId),
    },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = params?.id as keyof typeof SANGJO_PRODUCTS;
  const defaultSangjo = SANGJO_PRODUCTS[id][0];

  const sangjoTotalPricesDescription = SANGJO_PRODUCTS[id]
    .map(({ productName, totalPaymentDates, monthPaymentPrice }) => {
      const totalPrice = Number(totalPaymentDates) * Number(monthPaymentPrice);

      return `(${productName} - 최대 ${totalPrice.toLocaleString()}원), `;
    })
    .join("");

  const { companyName } = defaultSangjo;

  const title = `${companyName} 해지 환급금 계산기 | 헤이상조`;
  const description = `${companyName} 해지 환급금 ${sangjoTotalPricesDescription}손해보지 말고 정확한 상조 해지 환급금을 수령하세요. 납부 횟수를 기반으로 계산한 예상 환급금 계산기`;
  const keywords = `${companyName}, ${companyName} 해지, ${companyName} 상조 해지, ${companyName} 해지 환급금, ${companyName} 환급, ${companyName} 환급금 계산기, ${companyName} 내상조 찾아줘, 내상조 찾아줘, 상조 해지, 상조 해지 환급금, 상조 환급, 상조 환급금 계산기, 상조 해지 환급금 계산기`;

  return {
    props: {
      defaultSangjo: defaultSangjo,
      pageDescription: description,
      pageKeywords: keywords,
      pageOgTitle: title,
      pageOgDescription: description,
      pageOgImage: "",
    },
  };
};

const RefundCalculatorDetailPage = ({
  defaultSangjo,
}: InferGetStaticPropsType<typeof getStaticProps>) => {
  const sangjoName = defaultSangjo.companyName;

  return (
    <SangjoPageLayout title={`${sangjoName} 환급금 계산기`}>
      <Spacing gap={24} />
      <RefundCalculatorDetailContainer sangjoName={sangjoName} />
    </SangjoPageLayout>
  );
};

export default RefundCalculatorDetailPage;
